import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0732 = React.lazy(() => import('./symbols/0732_polution_ecology_factory'));
const Symbol0733 = React.lazy(() => import('./symbols/0733_polution_ecology_factory'));
const Symbol0734 = React.lazy(() => import('./symbols/0734_polution_oil'));
const Symbol0735 = React.lazy(() => import('./symbols/0735_polution_oil_refinery'));
const Symbol0736 = React.lazy(() => import('./symbols/0736_polution_co2_emissions'));
const Symbol0737 = React.lazy(() => import('./symbols/0737_fuel_petrol_tank_reserve_car'));
const Symbol0738 = React.lazy(() => import('./symbols/0738_polution_sea_water_dead_fish'));
const Symbol0739 = React.lazy(() => import('./symbols/0739_electricity_high_voltage_landline'));
const Symbol0740 = React.lazy(() => import('./symbols/0740_water_hydrant_fire'));
const Symbol0741 = React.lazy(() => import('./symbols/0741_water_pipe_drink'));
const Symbol0742 = React.lazy(() => import('./symbols/0742_wind_energy_power_turbines'));
const Symbol0743 = React.lazy(() => import('./symbols/0743_sun_energy_power_electricity'));
const Symbol0744 = React.lazy(() => import('./symbols/0744_sun_clouds_weather'));
const Symbol0745 = React.lazy(() => import('./symbols/0745_home_energy_efficient_eco'));
const Symbol0746 = React.lazy(() => import('./symbols/0746_home_energy_efficient_eco'));
const Symbol0747 = React.lazy(
  () => import('./symbols/0747_home_energy_heating_cooling_aircondition')
);
const Symbol0748 = React.lazy(() => import('./symbols/0748_home_energy_heating_winter_fire'));
const Symbol0749 = React.lazy(
  () => import('./symbols/0749_ecology_earth_polution_efficiency_green_energy')
);
const Symbol0750 = React.lazy(() => import('./symbols/0750_ecology_earth_clean_green_energy'));
const Symbol0751 = React.lazy(() => import('./symbols/0751_rechargeable_batteries_recycling'));
const Symbol0752 = React.lazy(() => import('./symbols/0752_ecology_car_clean_green_energy'));
const Symbol0753 = React.lazy(
  () => import('./symbols/0753_electro_hybrid_tesla_ecology_car_clean_green_energy')
);
const Symbol0754 = React.lazy(
  () => import('./symbols/0754_electro_hybrid_tesla_ecology_car_clean_green_energy')
);
const Symbol0755 = React.lazy(
  () => import('./symbols/0755_ecology_environment_forest_tree_green_park')
);
const Symbol0756 = React.lazy(
  () => import('./symbols/0756_ecology_environment_forest_tree_green_park')
);
const Symbol0757 = React.lazy(() => import('./symbols/0757_ecology_environment_green'));
const Symbol0758 = React.lazy(() => import('./symbols/0758_energy_efficiency_saving_light'));
const Symbol0759 = React.lazy(() => import('./symbols/0759_energy_efficiency_saving_light'));

export interface IProps {}

const Environment: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0732_polution_ecology_factory" symbol={<Symbol0732 />} />
      <LazySymbol id="0733_polution_ecology_factory" symbol={<Symbol0733 />} />
      <LazySymbol id="0734_polution_oil" symbol={<Symbol0734 />} />
      <LazySymbol id="0735_polution_oil_refinery" symbol={<Symbol0735 />} />
      <LazySymbol id="0736_polution_co2_emissions" symbol={<Symbol0736 />} />
      <LazySymbol id="0737_fuel_petrol_tank_reserve_car" symbol={<Symbol0737 />} />
      <LazySymbol id="0738_polution_sea_water_dead_fish" symbol={<Symbol0738 />} />
      <LazySymbol id="0739_electricity_high_voltage_landline" symbol={<Symbol0739 />} />
      <LazySymbol id="0740_water_hydrant_fire" symbol={<Symbol0740 />} />
      <LazySymbol id="0741_water_pipe_drink" symbol={<Symbol0741 />} />
      <LazySymbol id="0742_wind_energy_power_turbines" symbol={<Symbol0742 />} />
      <LazySymbol id="0743_sun_energy_power_electricity" symbol={<Symbol0743 />} />
      <LazySymbol id="0744_sun_clouds_weather" symbol={<Symbol0744 />} />
      <LazySymbol id="0745_home_energy_efficient_eco" symbol={<Symbol0745 />} />
      <LazySymbol id="0746_home_energy_efficient_eco" symbol={<Symbol0746 />} />
      <LazySymbol id="0747_home_energy_heating_cooling_aircondition" symbol={<Symbol0747 />} />
      <LazySymbol id="0748_home_energy_heating_winter_fire" symbol={<Symbol0748 />} />
      <LazySymbol
        id="0749_ecology_earth_polution_efficiency_green_energy"
        symbol={<Symbol0749 />}
      />
      <LazySymbol id="0750_ecology_earth_clean_green_energy" symbol={<Symbol0750 />} />
      <LazySymbol id="0751_rechargeable_batteries_recycling" symbol={<Symbol0751 />} />
      <LazySymbol id="0752_ecology_car_clean_green_energy" symbol={<Symbol0752 />} />
      <LazySymbol
        id="0753_electro_hybrid_tesla_ecology_car_clean_green_energy"
        symbol={<Symbol0753 />}
      />
      <LazySymbol
        id="0754_electro_hybrid_tesla_ecology_car_clean_green_energy"
        symbol={<Symbol0754 />}
      />
      <LazySymbol id="0755_ecology_environment_forest_tree_green_park" symbol={<Symbol0755 />} />
      <LazySymbol id="0756_ecology_environment_forest_tree_green_park" symbol={<Symbol0756 />} />
      <LazySymbol id="0757_ecology_environment_green" symbol={<Symbol0757 />} />
      <LazySymbol id="0758_energy_efficiency_saving_light" symbol={<Symbol0758 />} />
      <LazySymbol id="0759_energy_efficiency_saving_light" symbol={<Symbol0759 />} />
    </>
  );
});

Environment.displayName = 'Environment';

export default Environment;
